import React, {useState} from "react";
import { Link } from "react-router-dom";
import { AppRoutes, UserTableProps } from "../../utils/props"

const UserTable: React.FC<UserTableProps> = ({
  users,
  onDelete,
  onPrevPage,
  onNextPage,
  currentPage,
  totalPages,
}) => {
  return (
    <div className="w-full mt-5">
      <div className="w-full overflow-x-auto">
        <table className="min-w-full border-collapse">
          <thead>
            <tr>
              <th className="whitespace-nowrap text-left px-4 py-2 text-gray-400 font-semibold text-s uppercase border-b border-blue-300">Name</th>
              <th className="whitespace-nowrap text-left px-4 py-2 text-gray-400 font-semibold text-s uppercase border-b border-blue-300">Email</th>
              <th className="whitespace-nowrap text-left px-4 py-2 text-gray-400 font-semibold text-s uppercase border-b border-blue-300">Profile</th>
              <th className="whitespace-nowrap text-left px-4 py-2 text-gray-400 font-semibold text-s uppercase border-b border-blue-300">Delete</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.id} className="hover:bg-gray-100">
                <td className="whitespace-nowrap px-4 py-2 border-b border-blue-300">{user.name}</td>
                <td className="whitespace-nowrap px-4 py-2 border-b border-blue-300">{user.mail}</td>
                <td className="whitespace-nowrap px-4 py-2 border-b border-blue-300">
                  <Link className="hover:underline" to={`/user-information/${user.id}`}>View Profile</Link>
                </td>
                <td className="whitespace-nowrap px-4 py-2 border-b border-blue-300">
                  <button
                    className="hover:underline"
                    onClick={() => onDelete(user.id)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="w-full flex items-center justify-between mt-4 gap-2">
        <button
          disabled={currentPage === 1}
          onClick={onPrevPage}
          className={`px-3 py-1 rounded ${
            currentPage === 1
              ? "bg-gray-200 text-gray-500 cursor-not-allowed"
              : "bg-blue-500 text-white hover:bg-blue-600"
          }`}
        >
          Previous
        </button>
        <span className="text-sm text-gray-500">
          Page {currentPage} of {totalPages}
        </span>
        <button
          disabled={currentPage >= totalPages}
          onClick={onNextPage}
          className={`px-3 py-1 rounded ${
            currentPage >= totalPages
              ? "bg-gray-200 text-gray-500 cursor-not-allowed"
              : "bg-blue-500 text-white hover:bg-blue-600"
          }`}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default UserTable;